export const MESSAGE_CHARACTERS_LIMIT = 1000
export const INPUT_CHARACTERS_LIMIT = 40;
export const VALIDATION_MESSAGES = {
  FIELD_REQUIRED: 'This field is required',
  CHARACTER_LIMIT: (chars = INPUT_CHARACTERS_LIMIT) => `${chars} character limit`,
}
